module.exports = __webpack_public_path__ + "static/Opera-0f4d18f210a90a9473d8f6be9099e0f8.png";